export default "__VITE_ASSET__DBDHdYaE__"